import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const Fence = createSvgIcon(
  <path d="M10.5 3.615 6.375.005 2.25 3.615V7.5H0v2.25h2.25V15H0v2.25h2.25V24h8.25v-6.75h3V24h8.25v-6.75H24V15h-2.25V9.75H24V7.5h-2.25V3.615L17.625.005 13.5 3.615V7.5h-3V3.615Zm-6 18.135V4.635l1.875-1.64 1.875 1.64V21.75H4.5Zm9-6.75h-3V9.75h3V15Zm2.25-10.365 1.875-1.64 1.875 1.64V21.75h-3.75V4.635Z" />,
  'Fence'
);

export { Fence };